export default __webpack_public_path__ + "static/media/white_royal_queen.b7f45e58.png";